/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCollectionSliderViewProps } from '../../../modules/hosports-collection-slider/./hosports-collection-slider';
import Slider from './../../../baseComponents/slider/./slider';
import Banner from './../../../baseComponents/banner/./banner';
//@ts-ignore
import {HyperliteCollections} from './../utilities/constants';

export default (props: IHosportsCollectionSliderViewProps) => {
    let config = props.config;
    let collections = HyperliteCollections;
    if(config.brand == "hosports"){
      collections = [];
    }
    return (
      <Slider>
        {collections && collections.map((collection:any)=>{
          return(
            <div className="collection-slide">
              <Banner
                title={collection.title}
                image={collection.image}
                mobileImage={collection.mobileImage}
                buttonText={collection.button}
                link={collection.link}
                height="full"
                verticalPosition="center"
                horizontalPosition="left"
              />
            </div>
          )
        })}
      </Slider>
    );
};
